import { render, staticRenderFns } from "./SvehiclesalesreceiptView.vue?vue&type=template&id=6498d6b2&scoped=true"
import script from "./SvehiclesalesreceiptView.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesreceiptView.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesreceiptView.vue?vue&type=style&index=0&id=6498d6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6498d6b2",
  null
  
)

export default component.exports